/**
 * Lenis Smooth Scroll Initialization
 * Replicates mfisher.com's premium scroll feeling
 */

(function () {
    if (typeof Lenis === 'undefined') {
        console.warn('Lenis library not loaded');
        return;
    }

    // Initialize Lenis with mfisher.com-inspired settings
    const lenis = new Lenis({
        duration: 1.2,        // Speed of the scroll animation
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Natural easing curve
        lerp: 0.1,            // Linear interpolation factor - creates the "resistance" feeling
        wheelMultiplier: 1,   // Mouse wheel sensitivity
        touchMultiplier: 2,   // Touch/trackpad sensitivity
        infinite: false,
        gestureOrientation: 'vertical',
        normalizeWheel: true, // Smooths out different mouse wheel behaviors
        smoothWheel: true,    // Enable smooth wheel scrolling
    });

    // Add lenis class to html element
    document.documentElement.classList.add('lenis');

    // Animation frame loop
    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Expose lenis globally for debugging
    window.lenis = lenis;

    // Handle anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const href = this.getAttribute('href');
            if (href !== '#' && href !== '') {
                e.preventDefault();
                const target = document.querySelector(href);
                if (target) {
                    lenis.scrollTo(target, {
                        offset: 0,
                        duration: 1.5
                    });
                }
            }
        });
    });

    console.log('✨ Lenis smooth scroll initialized');
})();
